module.exports = __webpack_public_path__ + "static/media/SolutionSvg.7f8547ae.svg";